module.exports = __webpack_public_path__ + "img/shop11de.0b60eb1c.png";